import type { AuthState } from '../context/AweniContext';
import type { ModuleDescriptor } from '@/types';

export type RouteGateDecision = 'ALLOW' | 'REDIRECT_LOGIN' | 'REDIRECT_UPGRADE';

export function evaluate(moduleDef: ModuleDescriptor, auth: AuthState): RouteGateDecision {
  if (!moduleDef.guestAllowed && !auth.isAuthenticated) {
    return 'REDIRECT_LOGIN';
  }

  if (moduleDef.requiredPlan === 'free') {
    return 'ALLOW';
  }

  if (!auth.isAuthenticated) {
    return 'REDIRECT_LOGIN';
  }

  return auth.user?.is_guest ? 'REDIRECT_UPGRADE' : 'ALLOW';
}
